<nz-divider></nz-divider>
<h3>Customs Clearance:</h3>
<form nz-form *ngIf="load" [formGroup]="cusomsClearanceGroup">
  <div nz-row>
    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired>Customs Clearance Status</nz-form-label>
        <nz-form-control
          [nzErrorTip]="'Rejection Reason is Required'"
          nzValidateStatus="validating"
        >
          <nz-select
            required
            formControlName="clearanceStatus"
            id="clearanceStatus"
            (ngModelChange)="clearanceStatusChange($event)"
          >
            <nz-option
              *ngFor="let action of inspectionStatusList"
              [nzValue]="action.label"
              [nzLabel]="action.label"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div
      nz-col
      nzXl="12"
      nzLg="12"
      nzMd="24"
      nzSm="24"
      nzXs="24"
      *ngIf="showrejectionReason"
    >
      <nz-form-item class="ml-lg">
        <nz-form-label nzRequired>
          Rejection Reason
          <span nz-tooltip nzTitle="Rejection Reason">
            <i
              nz-icon
              class="icon-q"
              nzType="question-circle"
              nzTheme="outline"
            ></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Rejection Reason is Required'">
          <nz-select
            required
            [nzPlaceHolder]="'Rejection Reason'"
            id="rejectionReason"
            formControlName="rejectionReason"
          >
            <nz-option
              *ngFor="let fa of rejectionReasonList"
              [nzLabel]="fa.label"
              [nzValue]="fa.label"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="ml-lg">
        <nz-form-label>Comments</nz-form-label>
        <nz-form-control nzValidateStatus="validating">
          <textarea
            rows="2"
            id="comments"
            formControlName="comments"
            nz-input
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div class="float-right">
        <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
      </div>
    </div>
  </div>
</form>
